<div class="loader-wrapper" *ngIf="loading">
  <tui-loader size="l"></tui-loader>
</div>

<div class="error-wrapper" *ngIf="loadError && !loading">
  <header class="sidebar-header-error">
    <span class="sidebar-header-title">
      {{ "service_manager.gantt_sidebar.error" | translate }}
    </span>
    <button class="close-btn" (click)="close()">&times;</button>
  </header>
  <div class="text-error-container">
    <span class="error-text">
      {{ "service_manager.gantt_sidebar.load_error" | translate }}
    </span>
  </div>
</div>

<div *ngIf="details$ | async as d" class="modal-all">
  <!-- ============ CABECERA ============ -->
  <header class="sidebar-header">
    <div class="sidebar-header-text">
      <span class="sidebar-header-title">
        {{ serviceTypeLabel }} –
        {{ service.orderHash }}
      </span>
      <span
        *ngIf="
          isCopec &&
          getMobilityServiceTypeLabelKey(
            service.serviceTypeMobility
          ) as mobilityKey
        "
        class="sidebar-header-subtitle"
      >
        {{ mobilityKey | translate }}
      </span>
    </div>
    <button class="close-btn" (click)="close()">&times;</button>
  </header>

  <!-- ============ CONTENIDO SCROLLABLE ============ -->
  <div
    class="actions-container"
    #actionsRoot
    [style.justify-content]="
      details?.isServiceDelayed && delayedGuidValid
        ? 'space-between'
        : 'flex-end'
    "
  >
    <div
      class="warnings-container warnings-container-processed"
      *ngIf="details?.isServiceDelayed && delayedGuidValid"
      status="alert"
      closable="false"
    >
      <tui-svg tuiAlertIcon class="warn-icon" src="tuiIconFlag"></tui-svg>
      <div class="alert-content alert-content-processed">
        {{
          details?.delayType === delayType.CAFLER
            ? ("service_manager.gantt_sidebar.service_delayed_by_cafler"
              | translate)
            : details?.delayType === delayType.CLIENT
            ? ("service_manager.gantt_sidebar.service_delayed_by_client"
              | translate)
            : ""
        }}
      </div>
    </div>

    <div class="actions" #actionsRoot [class.open]="showMenu">
      <!-- Botón desplegable -->
      <button
        class="actions-btn"
        aria-haspopup="menu"
        [attr.aria-expanded]="showMenu"
        (click)="toggleMenu($event)"
      >
        <span>{{ "service_manager.gantt_sidebar.actions" | translate }}</span>
        <tui-svg src="tuiIconChevronDown"></tui-svg>
      </button>

      <!-- Menú -->
      <ul
        class="actions-menu"
        *ngIf="showMenu"
        role="menu"
        (click)="$event.stopPropagation()"
      >
        <!-- 1. Ver detalle -->
        <li>
          <button
            type="button"
            class="dropdown-item"
            role="menuitem"
            (click)="openServiceDetail()"
          >
            <tui-svg src="tuiIconEye"></tui-svg>
            <span class="item-label">
              {{
                "service_manager.gantt_sidebar.view_service_details" | translate
              }}
            </span>
          </button>
        </li>

        <!-- 2. Editar / Cancelar -->
        <li *ngIf="!editMode">
          <button
            type="button"
            class="dropdown-item"
            role="menuitem"
            [disabled]="service.nodeType !== 'OPERATIVE_NODE'"
            (click)="toggleEdit(); showMenu = false"
          >
            <tui-svg src="tuiIconEdit2"></tui-svg>
            <span class="item-label">
              {{ "service_manager.gantt_sidebar.edit" | translate }}
            </span>
          </button>
        </li>

        <li>
          <button
            type="button"
            class="dropdown-item"
            role="menuitem"
            (click)="removeServiceLateStatus()"
            *ngIf="details?.isServiceDelayed"
          >
            <img src="{{ whiteFlagIcon }}" alt="" />
            <span class="item-label">
              {{
                "service_manager.gantt_sidebar.remove_late_status" | translate
              }}
            </span>
          </button>
        </li>
        <li>
          <button
            type="button"
            class="dropdown-item"
            role="menuitem"
            (click)="modifityLateService()"
            *ngIf="details?.isServiceDelayed"
          >
            <ng-container *ngIf="!delayedGuidValid; else delayProcessed">
              <img src="../../../../../assets/icons/plus-black.svg" alt="" />
              <span class="item-label">
                {{
                  "service_manager.gantt_sidebar.add_late_reason" | translate
                }}
              </span>
            </ng-container>
            <ng-template #delayProcessed>
              <tui-svg src="tuiIconEdit2"></tui-svg>
              <span class="item-label">
                {{
                  "service_manager.gantt_sidebar.modify_late_service"
                    | translate
                }}
              </span>
            </ng-template>
          </button>
        </li>
        <li>
          <button
            type="button"
            class="dropdown-item"
            role="menuitem"
            (click)="cancelService()"
          >
            <tui-svg src="tuiIconClose" class="icon--red"></tui-svg>
            <span class="item-label red-text">
              {{ "service_manager.gantt_sidebar.cancel_service" | translate }}
            </span>
          </button>
        </li>
      </ul>
    </div>
  </div>

  <div
    class="warnings-wrapper"
    *ngIf="details?.isServiceDelayed && !delayedGuidValid"
  >
    <div class="warnings-container" status="alert" closable="false">
      <img
        class="warn-icon"
        src="../../../assets/icons/icons_solid_exclamation_circle.webp"
        alt=""
      />
      <div class="alert-content">
        {{
          "service_manager.gantt_sidebar.service_delayed_undefined" | translate
        }}
      </div>
    </div>
  </div>

  <form [formGroup]="form" class="modal-body">
    <!-- ===== Acordeón: Información básica ===== -->
    <tui-accordion>
      <tui-accordion-item [open]="true">
        <span class="section-title">
          {{ "service_manager.gantt_sidebar.basic_info" | translate }}
        </span>

        <ng-template tuiAccordionItemContent>
          <dl>
            <!-- Cliente -->
            <dt class="label-title">
              {{ "service_manager.gantt_sidebar.client" | translate }}
            </dt>
            <dd class="label-text">{{ d.clientName }}</dd>

            <!-- Zona -->
            <dt class="label-title">
              {{ "service_manager.gantt_sidebar.zone" | translate }}
            </dt>
            <dd class="label-text">{{ d.zoneName }}</dd>

            <!-- Punto recogida -->
            <dt class="label-title">
              {{ "service_manager.gantt_sidebar.pickup_point" | translate }}
            </dt>
            <dd *ngIf="!editMode" class="label-text">
              {{ d.originLocation.address }}
            </dd>
            <input
              #pickupInput
              formControlName="pickupAddress"
              class="input-standar"
              *ngIf="editMode"
              placeholder="Av. Diagonal 615, Barcelona"
            />

            <dt class="label-title" *ngIf="d.providerUbication?.length">
              {{ "service_manager.gantt_sidebar.provider_point" | translate }}
            </dt>

            <dd *ngIf="d.providerUbication?.length" class="label-text">
              <ng-container
                *ngIf="d.providerUbication.length === 1; else multipleProviders"
              >
                {{ d.providerUbication[0].address }}
              </ng-container>

              <ng-template #multipleProviders>
                <ul class="provider-list">
                  <li *ngFor="let p of d.providerUbication" class="label-text">
                    {{ p.address }}
                  </li>
                </ul>
              </ng-template>
            </dd>

            <!-- Punto entrega -->
            <dt class="label-title">
              {{ "service_manager.gantt_sidebar.dropoff_point" | translate }}
            </dt>
            <dd *ngIf="!editMode" class="label-text">
              {{ d.destinationLocation.address }}
            </dd>

            <input
              #dropoffInput
              formControlName="dropoffAddress"
              class="input-standar"
              *ngIf="editMode"
              placeholder="C/ Alcalá 45, Madrid"
            />

            <!-- Fecha -->
            <dt class="label-title">
              {{ "service_manager.gantt_sidebar.date" | translate }}
            </dt>
            <dd *ngIf="!editMode" class="label-text">
              {{ formatDateGrpc(d.routeInformation.assignedDate) }}
            </dd>

            <input
              *ngIf="editMode"
              type="date"
              formControlName="date"
              class="input-standar"
              placeholder="YYYY-MM-DD"
            />
            <!-- Hora de recogida (a que hora va el driver) -->
            <dt class="label-title mr-8">
              <span>
                {{ "service_manager.gantt_sidebar.pickup_time" | translate }}
              </span>

              <!-- tool tip -->
              <span
                class="info-icon-wrapper"
                (click)="$event.stopPropagation()"
              >
                <span #pickupTooltip class="visually-hidden">
                  {{
                    "service_manager.gantt_sidebar.pickup_time_tooltip"
                      | translate
                  }}
                </span>
                <img
                  [src]="grayInfoIcon"
                  width="16"
                  height="16"
                  alt=""
                  tabindex="0"
                  (mouseenter)="
                    showManualTooltip($event, pickupTooltip.textContent)
                  "
                  (mouseleave)="hideManualTooltip()"
                  (focus)="showManualTooltip($event, pickupTooltip.textContent)"
                  (blur)="hideManualTooltip()"
                  (keydown.escape)="hideManualTooltip()"
                />
              </span>
            </dt>

            <!-- Readonly view -->
            <dd *ngIf="!editMode" class="label-text">
              {{ formatHourGrpc(d.routeInformation.assignedDate.completeDate) }}
              –
              {{ formatHourGrpc(d.routeInformation.endDate?.completeDate) }}
            </dd>

            <!-- Editable pickup time (solo en editMode) -->
            <div *ngIf="editMode" class="schedule-edit-row">
              <tui-input
                tuiMask="HH:mm"
                formControlName="startTime"
                class="custom-field time-field"
                size="m"
                maxlength="5"
                placeholder="00:00"
                (input)="onTimeTyped($event, 'startTime')"
              ></tui-input>

              <span class="separator">–</span>

              <tui-input
                tuiMask="HH:mm"
                formControlName="endTime"
                class="custom-field time-field"
                size="m"
                maxlength="5"
                placeholder="23:59"
                (input)="onTimeTyped($event, 'endTime')"
              ></tui-input>
            </div>

            <!-- Horario (nodo) (SIEMPRE readonly: horas solicitadas por el cliente) -->
            <dt class="label-title mr-8">
              <span>{{
                "service_manager.gantt_sidebar.schedule" | translate
              }}</span>

              <span
                class="info-icon-wrapper"
                (click)="$event.stopPropagation()"
              >
                <span #scheduleTooltip class="visually-hidden">
                  {{
                    "service_manager.gantt_sidebar.schedule_tooltip" | translate
                  }}
                </span>

                <img
                  [src]="grayInfoIcon"
                  width="16"
                  height="16"
                  alt=""
                  tabindex="0"
                  (mouseenter)="
                    showManualTooltip($event, scheduleTooltip.textContent)
                  "
                  (mouseleave)="hideManualTooltip()"
                  (focus)="
                    showManualTooltip($event, scheduleTooltip.textContent)
                  "
                  (blur)="hideManualTooltip()"
                  (keydown.escape)="hideManualTooltip()"
                />
              </span>
            </dt>

            <dd *ngIf="!editMode" class="label-text">
              {{ formatHourGrpc(d.startDate?.completeDate) }}
              –
              {{ formatHourGrpc(d.endDate?.completeDate) }}
            </dd>

            <div *ngIf="editMode" class="schedule-edit-row">
              <tui-input
                tuiMask="HH:mm"
                formControlName="serviceStartTime"
                class="custom-field time-field"
                size="m"
                maxlength="5"
                placeholder="00:00"
                (input)="onTimeTyped($event, 'serviceStartTime')"
              ></tui-input>

              <span class="separator">–</span>

              <tui-input
                tuiMask="HH:mm"
                formControlName="serviceEndTime"
                class="custom-field time-field"
                size="m"
                maxlength="5"
                placeholder="23:59"
                (input)="onTimeTyped($event, 'serviceEndTime')"
              ></tui-input>
            </div>

            <!-- Matrícula -->
            <dt class="label-title">
              {{ "service_manager.gantt_sidebar.license_plate" | translate }}
            </dt>
            <dd *ngIf="!editMode" class="label-text">
              {{ d.vehicleInformation.licensePlate || "-" }}
            </dd>
            <tui-input
              *ngIf="editMode"
              class="custom-field"
              size="m"
              formControlName="licensePlate"
            ></tui-input>

            <!-- Combustible -->
            <dt class="label-title">
              {{ "service_manager.gantt_sidebar.fuel" | translate }}
            </dt>
            <dd class="label-text">
              {{
                VehicleFuelLabelKeys[d.vehicleInformation.fuelType] | translate
              }}
            </dd>

            <!-- Estado del nodo (lectura / edición) -->
            <dt class="label-title">
              {{
                "service_manager.gantt_sidebar.node_status_label" | translate
              }}
            </dt>
            <dd class="label-text">
              <!-- modo lectura -->
              <ng-container *ngIf="!editMode">
                <ng-container
                  *ngIf="
                    d.nodeStatus !== undefined && d.nodeStatus !== null;
                    else nodeStatusMissing
                  "
                >
                  {{ getNodeStatusLabel(d.nodeStatus) }}
                </ng-container>
                <ng-template #nodeStatusMissing>–</ng-template>
              </ng-container>

              <ng-container *ngIf="editMode">
                <ng-select
                  formControlName="nodeStatus"
                  [items]="statuses"
                  bindLabel="label"
                  bindValue="code"
                  [clearable]="false"
                  placeholder="Selecciono un estado"
                  aria-label="Node status"
                  class="w-100"
                  appendTo="body"
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.label }}
                  </ng-template>
                </ng-select>
              </ng-container>
            </dd>

            <!-- Comentarios -->
            <dt class="label-title">
              {{ "service_manager.gantt_sidebar.comments" | translate }}
            </dt>
            <dd class="label-text">
              {{ d.clientComments || "-" }}
            </dd>
          </dl>
        </ng-template>
      </tui-accordion-item>
    </tui-accordion>

    <!-- ===== Acordeón: Información de ruta ===== -->
    <tui-accordion>
      <tui-accordion-item [open]="true">
        <span class="section-title">
          {{ "service_manager.gantt_sidebar.route_info" | translate }}
        </span>
        <ng-template tuiAccordionItemContent>
          <ng-container *ngTemplateOutlet="routeBlock"></ng-container>
        </ng-template>
      </tui-accordion-item>
    </tui-accordion>

    <!-- ===== Acordeón: Conductores asignados ===== -->
    <tui-accordion>
      <tui-accordion-item [open]="true">
        <span class="section-title">
          {{ "service_manager.gantt_sidebar.assigned_drivers" | translate }}
        </span>
        <ng-template tuiAccordionItemContent>
          <ng-container
            *ngTemplateOutlet="driversBlock; context: { $implicit: d }"
          ></ng-container>
        </ng-template>
      </tui-accordion-item>
    </tui-accordion>

    <!-- ========== BLOQUE RUTA ========== -->
    <ng-template #routeBlock>
      <div
        *ngIf="durationTotal !== null && durationTotal !== undefined"
        class="durations-container"
      >
        <!-- Conductor (coche) -->
        <ng-container *ngIf="mapType === mapKind.Driver; else transitMode">
          <div class="durantions-driver-container">
            <span class="label-title">
              {{
                "service_manager.gantt_sidebar.total_driving_time" | translate
              }}
            </span>
            <span class="label-text">{{ human(durationTotal) }}</span>
          </div>
        </ng-container>

        <!-- Transporte público -->
        <ng-template #transitMode>
          <div class="duration-row three-cols">
            <div class="duration-col">
              <span class="label-title">
                {{ "service_manager.gantt_sidebar.total_time" | translate }}
              </span>
              <span class="label-text">{{ human(durationTotal) }}</span>
            </div>
            <div class="duration-col">
              <span class="label-title">
                {{ "service_manager.gantt_sidebar.transit_time" | translate }}
              </span>
              <span class="label-text">{{ human(durationTransit) }}</span>
            </div>
            <div class="duration-col">
              <span class="label-title">
                {{ "service_manager.gantt_sidebar.walking_time" | translate }}
              </span>
              <span class="label-text">{{ human(durationWalking) }}</span>
            </div>
          </div>
        </ng-template>
      </div>

      <div #gmap class="map_modal"></div>

      <!-- avisos -->
      <div
        class="warnings-container mt-2"
        *ngIf="routeWarningKey$ | async as warn"
        role="alert"
      >
        <tui-svg src="tuiIconAlertCircle" class="warn-icon"></tui-svg>
        <span class="warn-text">{{ warn | translate }}</span>
      </div>

      <div
        class="warnings-container mt-2"
        *ngIf="sameSpotNoticeKey as same"
        role="alert"
      >
        <tui-svg src="tuiIconAlertCircle" class="warn-icon"></tui-svg>
        <span class="warn-text">{{ same | translate }}</span>
      </div>

      <!-- botones modo ruta -->
      <div class="flex-container-end mt-12" *ngIf="!isService">
        <button
          *ngIf="mapType === mapKind.Public"
          class="blue-transparent-btn"
          (click)="onChangeMapType(mapKind.Driver)"
        >
          {{ "service_manager.gantt_sidebar.show_car_route" | translate }}
        </button>

        <button
          *ngIf="mapType === mapKind.Driver"
          class="blue-transparent-btn"
          (click)="onChangeMapType(mapKind.Public)"
        >
          {{ "service_manager.gantt_sidebar.show_public_route" | translate }}
        </button>
      </div>

      <!-- botón Google maps -->
      <div class="open-gmaps-container">
        <button
          class="blue-transparent-btn"
          type="button"
          (click)="openInGoogleMaps()"
        >
          {{ "service_manager.gantt_sidebar.open_in_google_maps" | translate }}
        </button>
      </div>
    </ng-template>

    <!-- ========== BLOQUE CONDUCTORES ========== -->

    <ng-template #driversBlock let-ui>
      <!-- 1️⃣ Conductor principal -->
      <ng-container *ngIf="getDriverData(ui, 'driver') as drv">
        <div class="driver-card">
          <div class="driver-card__top">
            <div class="driver-card__data">
              <span class="driver-card__label">
                {{ "service_manager.gantt_sidebar.driver" | translate }}
              </span>

              <!-- Nombre o texto “Sin asignar” -->
              <span class="driver-card__name">
                {{
                  isAssigned(drv)
                    ? drv.driverName
                    : ("service_manager.gantt_sidebar.no_driver" | translate)
                }}
              </span>
            </div>

            <!-- Botones -->
            <div class="driver-card__buttons">
              <!-- Asignar / Cambiar -->
              <button
                tuiButton
                appearance="flat"
                size="s"
                class="flat-button"
                (click)="openAssignDriverModal(false)"
              >
                <span class="driver-card-btn-text">
                  {{
                    isAssigned(drv)
                      ? ("service_manager.gantt_sidebar.change" | translate)
                      : ("service_manager.gantt_sidebar.assign" | translate)
                  }}
                </span>
              </button>

              <!-- Desasignar (solo si hay conductor) -->
              <button
                *ngIf="isAssigned(drv)"
                tuiButton
                appearance="flat"
                size="s"
                class="flat-button"
                (click)="openUnassignModal(drv, false)"
              >
                <span class="driver-card-btn-text">
                  {{ "service_manager.gantt_sidebar.unassign" | translate }}
                </span>
              </button>
            </div>
          </div>

          <!-- Toggle de bloqueo -->
          <div class="driver-card__lock" *ngIf="isAssigned(drv)">
            <tui-toggle
              class="custom-toggle-edit-client"
              size="l"
              [ngModel]="drv.isNodeLockedForDriverAssignation"
              (ngModelChange)="onLockToggle($event)"
              [ngModelOptions]="{ standalone: true }"
            ></tui-toggle>

            <div class="toggle-text-container">
              <span class="toggle-text">
                {{ "service_manager.gantt_sidebar.node_locked" | translate }}
              </span>
              <span class="tooltip-container">
                <img [src]="grayInfoIcon" width="16" height="16" alt="" />
                <span class="tooltip__text">
                  {{
                    "service_manager.gantt_sidebar.node_locked_hint" | translate
                  }}
                </span>
              </span>
            </div>
          </div>

        </div>
      </ng-container>

      <!-- Separador: solo si ambos están asignados -->
      <hr
        *ngIf="
          isAssigned(getDriverData(ui, 'driver')) &&
          isAssigned(getDriverData(ui, 'sweeper'))
        "
      />

      <!-- 2️⃣ Conductor “coche escoba” -->
      <ng-container *ngIf="getDriverData(ui, 'sweeper') as swarm">
        <div class="driver-card">
          <div class="driver-card__top">
            <div class="driver-card__data">
              <span class="driver-card__label">
                {{
                  "service_manager.gantt_sidebar.sweeper_car_driver" | translate
                }}
              </span>

              <span class="driver-card__name">
                {{
                  isAssigned(swarm)
                    ? swarm.driverName
                    : ("service_manager.gantt_sidebar.no_driver" | translate)
                }}
              </span>
            </div>

            <div class="driver-card__buttons">
              <!-- Asignar / Cambiar -->
              <button
                tuiButton
                appearance="flat"
                size="s"
                class="flat-button"
                (click)="openAssignDriverModal(true)"
              >
                <span class="driver-card-btn-text">
                  {{
                    isAssigned(swarm)
                      ? ("service_manager.gantt_sidebar.change" | translate)
                      : ("service_manager.gantt_sidebar.assign" | translate)
                  }}
                </span>
              </button>

              <!-- Desasignar (solo si hay conductor) -->
              <button
                *ngIf="isAssigned(swarm)"
                tuiButton
                appearance="flat"
                size="s"
                class="flat-button"
                (click)="openUnassignModal(swarm, true)"
              >
                <span class="driver-card-btn-text">
                  {{ "service_manager.gantt_sidebar.unassign" | translate }}
                </span>
              </button>
            </div>
          </div>

          <div class="driver-card__lock" *ngIf="isAssigned(swarm)">
            <tui-toggle
              class="custom-toggle-edit-client"
              size="l"
              [ngModel]="isNodeLockedForSweeperAssignation"
              (ngModelChange)="onSweeperLockToggle($event, swarm)"
              [ngModelOptions]="{ standalone: true }"
            ></tui-toggle>

            <div class="toggle-text-container">
              <span class="toggle-text">
                {{
                  "service_manager.gantt_sidebar.sweeper_node_locked"
                    | translate
                }}
              </span>
              <span class="tooltip-container">
                <img [src]="grayInfoIcon" width="16" height="16" alt="" />
                <span class="tooltip__text">
                  {{
                    "service_manager.gantt_sidebar.sweeper_node_locked_hint"
                      | translate
                  }}
                </span>
              </span>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-template>
  </form>

  <div class="modal-footer-edit" *ngIf="editMode">
    <button
      class="cancel-button"
      type="button"
      (click)="cancelEditModel()"
      [disabled]="isEditingGanttDetails"
    >
      {{ "service_manager.gantt_sidebar.cancel" | translate }}
    </button>

    <button class="confirm-button" type="button" (click)="saveChanges()">
      <ng-container *ngIf="isEditingGanttDetails; else labelTpl">
        <tui-loader size="xs"></tui-loader>
      </ng-container>

      <ng-template #labelTpl>
        <ng-container>
          <span>
            {{ "service_manager.gantt_sidebar.save" | translate }}
          </span>
        </ng-container>
      </ng-template>
    </button>
  </div>
</div>
